import {
  FlagBg,
  FlagCs,
  FlagDe,
  FlagEl,
  FlagEn,
  FlagEs,
  FlagFr,
  FlagHu,
  FlagIt,
  FlagJa,
  FlagKo,
  FlagNb,
  FlagNl,
  FlagPl,
  FlagPt,
  FlagPtBr,
  FlagRo,
  FlagRu,
  FlagSe,
  FlagTh,
  FlagTr,
  FlagVi,
  FlagZh,
  OrderProBadge,
  UnexpectedError,
  PageNotFound,
  UnauthorizedError
} from "./svg-asset-definition";


export default {
  FlagBg,
  FlagCs,
  FlagDe,
  FlagEl,
  FlagEn,
  FlagEs,
  FlagFr,
  FlagHu,
  FlagIt,
  FlagJa,
  FlagKo,
  FlagNb,
  FlagNl,
  FlagPl,
  FlagPt,
  FlagPtBr,
  FlagRo,
  FlagRu,
  FlagSe,
  FlagTh,
  FlagTr,
  FlagVi,
  FlagZh,
  OrderProBadge,
  UnexpectedError,
  PageNotFound,
  UnauthorizedError
}
